import React from "react";

import { Presenter } from "./Presenter";

import { Props } from "../../types/Heading03";

export const Heading03: React.VFC<Props> = (props) => {
  return <Presenter {...props} />;
};
